/* Pop&Go — comportamientos globales (cursor, magnetic, reveal, nav scroll,
   parallax de blobs, menú móvil, ESC). El carrito vive en cart.js.
   Config inyectada desde theme.liquid en window.POPGO. */
(function () {
  'use strict';
  var CFG = window.POPGO || {};
  var isTouch = window.matchMedia('(hover: none)').matches;

  /* ---------- Cursor personalizado ---------- */
  var cursor = document.getElementById('cursor');
  if (cursor && CFG.cursor !== false && !isTouch) {
    document.addEventListener('mousemove', function (e) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    });
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('a, button, .magnetic, summary')) cursor.classList.add('expand');
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest('a, button, .magnetic, summary')) cursor.classList.remove('expand');
    });
  } else if (cursor) {
    cursor.style.display = 'none';
  }

  /* ---------- Magnetic ---------- */
  function initMagnetic() {
    if (isTouch) return;
    document.querySelectorAll('.magnetic').forEach(function (el) {
      if (el.dataset.magBound) return;
      el.dataset.magBound = '1';
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + x * 0.18 + 'px,' + y * 0.18 + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }
  window.initMagnetic = initMagnetic;

  /* ---------- Reveal (re-ejecutable tras renders dinámicos) ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.1 });
  function observeReveals() {
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }
  window.observeReveals = observeReveals;

  /* ---------- Nav blanco + ship banner al hacer scroll ---------- */
  function onScroll() {
    var nav = document.getElementById('nav');
    var banner = document.getElementById('ship-banner');
    if (!nav) return;
    var scrolled = window.scrollY > 80;
    if (scrolled) {
      nav.classList.add('bg-blanco/90', 'backdrop-blur-md', 'shadow-sm');
      if (banner) banner.classList.remove('-translate-y-full', 'opacity-0');
    } else {
      nav.classList.remove('bg-blanco/90', 'backdrop-blur-md', 'shadow-sm');
      if (banner) banner.classList.add('-translate-y-full', 'opacity-0');
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Menú móvil ---------- */
  function toggleMobileMenu() {
    var menu = document.getElementById('mobile-menu');
    var btn = document.getElementById('menu-toggle');
    if (!menu) return;
    var open = menu.classList.toggle('open');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  window.toggleMobileMenu = toggleMobileMenu;

  /* ---------- Parallax de blobs (GSAP) ---------- */
  function initParallax() {
    if (CFG.parallax === false) return;
    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    gsap.utils.toArray('.blob').forEach(function (b, i) {
      gsap.to(b, {
        y: (i % 2 === 0 ? -120 : 120),
        scrollTrigger: { trigger: b.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1 }
      });
    });
  }

  /* ---------- ESC: cierra carro + menú móvil ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (window.closeCart) window.closeCart();
    var menu = document.getElementById('mobile-menu');
    if (menu && menu.classList.contains('open')) toggleMobileMenu();
  });

  /* ---------- Año dinámico ---------- */
  function setYear() {
    document.querySelectorAll('[data-year]').forEach(function (el) {
      el.textContent = new Date().getFullYear();
    });
  }

  function init() {
    observeReveals();
    initMagnetic();
    onScroll();
    initParallax();
    setYear();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
